// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__zTUGV","colMaxWidth":"Table_colMaxWidth__1Htna"};